import styled from "styled-components";

export const BannerContainer = styled.div`
    width: 100%;
    background: linear-gradient(90deg, #2563eb, #7c3aed);
    color: white;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
    font-weight: 500;
    z-index: 9999;
    position: fixed;
`;